<template>
  <div id="arquivosOuvidoria">
    <b-card header-tag="header" class="m-3" no-body>
      <b-overlay :show="loadingArquivos">
        <b-card-body v-if="arquivos && arquivos.length > 0">
          <b-row
            class="text-left m-3"
            v-for="(arquivo, index) in arquivos"
            :key="index"
          >
            <b-col
              cols="12"
              lg="6"
              class="d-flex flex-row flex-nowrap justify-content-start align-items-center"
            >
              <span>Arquivo: </span>&nbsp; <span>{{ arquivo.Descricao }}</span
              >&nbsp;
              <b-overlay :show="overlayBaixar">
                <b-button
                  size="sm"
                  @click="baixarArquivo(arquivo.Descricao, arquivo.IdArquivo)"
                >
                  <font-awesome-icon icon="download" />
                </b-button>
              </b-overlay>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-body v-else-if="!loadingArquivos">Não há arquivo.</b-card-body>
      </b-overlay>
    </b-card>
  </div>
</template>

<script lang="ts">
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { ArquivosManifestacao } from "@/types/administracao/ouvidoria/arquivos-manifestacao";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";

const CompProps = Vue.extend({
  name: "ArquivosOuvidoria",
  components: {},
  props: {
    idManifestacao: {
      type: Number,
      required: true,
    },
  },
});

@Component
export default class ArquivosOuvidoria extends mixins(UtilsTS, CompProps) {
  arquivos: ArquivosManifestacao[] = [];
  loadingArquivos = true;
  overlayBaixar = false;

  async loadArquivos(): Promise<void> {
    try {
      this.loadingArquivos = true;
      this.arquivos = await ouvidoriaService.getAllArquivosByManifestacaoId(
        Number(this.idManifestacao)
      );
      this.arquivos.reverse();
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingArquivos = false;
    }
  }

  async baixarArquivo(nomeArquivo: string, idArquivo: number) {
    try {
      this.overlayBaixar = true;
      const response = await ouvidoriaService.baixarArquivoManifestacao(
        idArquivo
      );
      this.download(nomeArquivo, response.data);
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.overlayBaixar = false;
    }
  }

  download(filename: string, content: any): void {
    var element = document.createElement("a");
    element.setAttribute("href", URL.createObjectURL(content));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  async mounted(): Promise<void> {
    await this.loadArquivos();
  }
}
</script>

<style scoped>
div span:first-of-type {
  font-weight: bold;
}
</style>